import type { LucideIcon } from 'lucide-react'
import { IconPlaceholder } from '@components/IconPlaceholder.tsx'
import type { SystemTags } from '@hewey/shared'
import { iconFor } from './recipeIcon.ts'

type Props = {
	// Stable string (recipe id) for the tint hash, so a given recipe always
	// looks the same.
	seed: string
	// The recipe's tags and title drive the content-based icon (see iconFor).
	tags?: SystemTags | null | undefined
	title: string
	// Explicit override — wins over the derived icon.
	icon?: LucideIcon | undefined
}

export const RecipePlaceholder = ({ seed, tags, title, icon }: Props) => (
	<IconPlaceholder seed={seed} icon={icon ?? iconFor(tags, title)} />
)
